export default __webpack_public_path__ + "static/media/youtube_icon.ad865f87.svg";